var React = require('react');

function Auditoria (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.98 10.918H4.42v1.264h11.56v-1.264zM15.98 14.912H4.42v1.265h11.56v-1.265zM15.98 18.904H4.42v1.265h11.56v-1.265z","strokeWidth":".3","key":0}),React.createElement("path",{"d":"M12.904.525L.7.5v23.564h19V7.296L12.904.525zm.372 2.158l4.266 4.266h-4.266V2.683zM1.965 22.799V1.765l10.046.025v6.424h6.424V22.8H1.965z","strokeWidth":".3","key":1})]);
}

Auditoria.defaultProps = {"width":"20","height":"25"};

module.exports = Auditoria;

Auditoria.default = Auditoria;
